module.exports = __webpack_public_path__ + "img/book-list.814bd8b.svg";